
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.33 47.05a6.7 6.7 0 109.44 9.51l27.49-27.28a14.2 14.2 0 0017.66-18.06l-10.7 8.5-6.77-6.83L49 2.26a14.2 14.2 0 00-18.17 17.51z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"8.14","cy":"51.71","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M35.93 24.3L11.74 48.31M35.38 16.27l8.49 8.49"}})])
          )
        }
      }
    